module.exports = __webpack_public_path__ + "static/img/1000000439.748391e1.jpg";